// API 엔드포인트 — 화면별 매핑은 docs/api/README.md 참고

const API_V1 = '/api/v1';
/** 웹 전용 인증 — 발급한 사용자 JWT로 /web/** · /api/v1/** 를 모두 호출한다 */
const WEB_AUTH = '/web/auth';
/** 웹 전용 거래처 · 실적 — 앱과 같은 테이블을 웹 모듈이 직접 읽는다 */
const WEB_BUSINESS_RELATIONSHIPS = '/web/business-relationships';
const WEB_PERFORMANCE = '/web/performance';
const WEB_DRUGS = '/web/drugs';

export const createApiPath = {
  /** M-01 · M-02 로그인 · 세션 */
  auth: {
    login: () => `${WEB_AUTH}/login`,
    refresh: () => `${WEB_AUTH}/refresh`,
    me: () => `${WEB_AUTH}/me`,
    socialLogin: (provider: 'kakao' | 'naver' | 'google' | 'apple') =>
      `${WEB_AUTH}/social/${provider}/login`,
  },

  /** M-04 ~ M-07 · M-19 ~ M-22 거래처 · 처방 등록 (웹 전용, 경로 키는 relationshipId) */
  businessRelationships: {
    list: () => WEB_BUSINESS_RELATIONSHIPS,
    detail: (relationshipId: number) =>
      `${WEB_BUSINESS_RELATIONSHIPS}/${relationshipId}`,
    trades: (relationshipId: number) =>
      `${WEB_BUSINESS_RELATIONSHIPS}/${relationshipId}/trades`,
    prescriptionRegistrations: (relationshipId: number) =>
      `${WEB_BUSINESS_RELATIONSHIPS}/${relationshipId}/prescription-registrations`,
    untradedDrugs: (relationshipId: number) =>
      `${WEB_BUSINESS_RELATIONSHIPS}/${relationshipId}/untraded-drugs`,
    presignedUrls: (relationshipId: number) =>
      `${WEB_BUSINESS_RELATIONSHIPS}/${relationshipId}/prescription-images/presigned-urls`,
    prescriptionImages: (relationshipId: number) =>
      `${WEB_BUSINESS_RELATIONSHIPS}/${relationshipId}/prescription-images`,
  },
  prescriptions: {
    /** M-16 확인 전 이미지 삭제 — 웹 API가 없어 앱 API를 쓴다 */
    deleteImage: (imageCode: string) =>
      `${API_V1}/prescription-settlements/clinics/images/${encodeURIComponent(imageCode)}`,
  },

  /** M-08 · M-09 · M-16 ~ M-18 실적 (웹 전용, {month}는 정산월 yyyyMM) */
  performance: {
    availableYears: () => `${WEB_PERFORMANCE}/available-years`,
    yearly: () => `${WEB_PERFORMANCE}/yearly`,
    monthlySummary: (month: string) =>
      `${WEB_PERFORMANCE}/monthly/${month}/summary`,
    clinics: (month: string) => `${WEB_PERFORMANCE}/monthly/${month}/clinics`,
    clinicTrend: (month: string, clinicId: number) =>
      `${WEB_PERFORMANCE}/monthly/${month}/clinics/${clinicId}/trend`,
    clinicDrugs: (month: string, clinicId: number) =>
      `${WEB_PERFORMANCE}/monthly/${month}/clinics/${clinicId}/drugs`,
    clinicPharmaCompanies: (month: string, clinicId: number) =>
      `${WEB_PERFORMANCE}/monthly/${month}/clinics/${clinicId}/pharma-companies`,
    clinicImages: (month: string, clinicId: number) =>
      `${WEB_PERFORMANCE}/monthly/${month}/clinics/${clinicId}/images`,
    imageDrugs: (month: string, clinicId: number, imageCode: string) =>
      `${WEB_PERFORMANCE}/monthly/${month}/clinics/${clinicId}/images/${encodeURIComponent(imageCode)}/drugs`,
    imageDownloadUrl: (month: string, clinicId: number, imageCode: string) =>
      `${WEB_PERFORMANCE}/monthly/${month}/clinics/${clinicId}/images/${encodeURIComponent(imageCode)}/download-url`,
    clinicExcel: (month: string, clinicId: number) =>
      `${WEB_PERFORMANCE}/monthly/${month}/clinics/${clinicId}/excel`,
  },

  /** M-10 ~ M-12 의약품 (웹 전용). drugCode = 심평원 보험코드 (딥링크 ?drug= 값과 같음) */
  drugs: {
    search: () => WEB_DRUGS,
    suggestions: () => `${WEB_DRUGS}/suggestions`,
    pharmaCompanies: () => `${WEB_DRUGS}/pharma-companies`,
    detail: (drugCode: string) =>
      `${WEB_DRUGS}/${encodeURIComponent(drugCode)}`,
    related: (drugCode: string) =>
      `${WEB_DRUGS}/${encodeURIComponent(drugCode)}/related`,
  },
};
